import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import win11StartLightBackground from './assets/win11-start-light-bgimage.svg';
import { getStartStyles } from './styles/win11-start-light-style';


export const Win11StartLight = ({
  styleOverrides,
}) => {
  const classes = useDefaultStyles(getStartStyles({ styleOverrides }));

  return (
    <div className={classnames('win-start-background', classes.startBackground)}>
      <img className={classnames('win-start-background-image', classes.background)} alt="" src={win11StartLightBackground} />
      <div className={classnames('win-start-ad-container', classes.adContainer)} />
    </div>
  );
};

Win11StartLight.propTypes = {
  styleOverrides: PropTypes.shape({}),
};

Win11StartLight.defaultProps = {
  styleOverrides: {},
};
